import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-purple-400 hover:text-purple-300 mb-4 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </button>
          <h1 className="text-4xl font-bold text-white mb-2">Terms and Conditions</h1>
          <p className="text-gray-400">Last updated: October 15, 2025</p>
        </div>

        {/* Content */}
        <div className="reaction-card space-y-6 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing and using Dexreaction's services, you accept and agree to be bound by the terms and provisions of this agreement. 
              If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">2. Services Description</h2>
            <p className="mb-2">
              Dexreaction provides DexScreener reaction services for cryptocurrency tokens. Our services include:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>DexScreener reaction purchases (Rocket, Fire, Diamond, etc.)</li>
              <li>Automated order processing</li>
              <li>Balance top-up and payment processing</li>
              <li>Customer support services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">3. User Responsibilities</h2>
            <p className="mb-2">As a user of our services, you agree to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use services only for legitimate purposes</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Not engage in fraudulent activities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">4. Payment Terms</h2>
            <p className="mb-2">
              All payments are processed securely through Solana blockchain or balance system:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Minimum order quantity: 500 reactions</li>
              <li>Payments are non-refundable once services are delivered</li>
              <li>All prices are displayed in USD</li>
              <li>Transaction fees may apply</li>
              <li>Voucher codes are subject to terms and expiration dates</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">5. Service Delivery</h2>
            <p className="mb-2">
              We strive to deliver services promptly:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Processing time typically within 24-48 hours</li>
              <li>Delivery times may vary based on order volume</li>
              <li>We do not guarantee specific ranking positions</li>
              <li>Services are subject to DexScreener's availability</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">6. Refund Policy</h2>
            <p className="mb-2">
              Refunds are handled on a case-by-case basis:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Services not delivered within reasonable time may be refunded</li>
              <li>Technical issues preventing delivery may qualify for refunds</li>
              <li>Refunds are not available for completed orders</li>
              <li>Contact support for refund requests</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">7. Prohibited Activities</h2>
            <p className="mb-2">Users are prohibited from:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Attempting to manipulate or abuse the service</li>
              <li>Using automated bots or scripts without authorization</li>
              <li>Reselling our services without permission</li>
              <li>Violating intellectual property rights</li>
              <li>Engaging in illegal activities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">8. Limitation of Liability</h2>
            <p>
              Dexreaction is not liable for any indirect, incidental, special, consequential, or punitive damages resulting from 
              your use of our services. We do not guarantee specific results or outcomes from using our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">9. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes 
              acceptance of the modified terms. We will notify users of significant changes via email or website notice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-3">10. Contact Information</h2>
            <p>
              For questions about these Terms and Conditions, please contact us through our support ticket system or email 
              at support@dexreaction.com
            </p>
          </section>

          <div className="mt-8 pt-6 border-t border-purple-500/20">
            <p className="text-sm text-gray-400">
              By using Dexreaction services, you acknowledge that you have read, understood, and agree to be bound by these 
              Terms and Conditions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
